import { j as o } from "./index.es33.js";
import { clsx as s } from "./index.es105.js";
import { formatDate as m } from "./index.es643.js";
import "./index.es434.js";
import { Typography as l } from "./index.es35.js";
import "./index.es36.js";
import { dateFormat as t } from "./index.es652.js";
import e from "./index.es659.js";
var y = function y(_ref) {
    var r = _ref.hoveredDate;
    return o.jsx("div", {
      className: e.placeholder,
      style: {
        left: "12px"
      },
      children: o.jsx(l.Body2, {
        className: e.placeholderItem,
        children: "".concat(m(r), " \u2014 ").concat(t)
      })
    });
  },
  j = function j(_ref2) {
    var r = _ref2.hoveredDate,
      a = _ref2.inputValue;
    return o.jsxs("div", {
      className: e.placeholder,
      style: {
        left: "15px"
      },
      children: [o.jsx(l.Body2, {
        className: s(e.placeholderItem, e.placeholderHidden),
        children: a
      }), o.jsx(l.Body2, {
        className: e.placeholderItem,
        children: m(r)
      })]
    });
  };
export { y as HoveredFromPlaceholder, j as HoveredToPlaceholder };